<template>
  <div class="modal-backdrop" @click.self="$emit('close')">
    <div class="modal-content">
      <button class="close-btn" type="button" @click="$emit('close')">×</button>
      <img v-if="type === 'image'" :src="src" alt="Медиа" />
      <video v-else controls :src="src"></video>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewMediaModal',
  props: {
    src: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'image'
    }
  }
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.65);
  display: grid;
  place-items: center;
  z-index: 1200;
  padding: 16px;
}

.modal-content {
  position: relative;
  max-width: min(960px, 95vw);
  max-height: min(720px, 90vh);
  background: #05070c;
  border-radius: 20px;
  overflow: hidden;
  display: grid;
  place-items: center;
}

img,
video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #05070c;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 12px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 1.4rem;
  cursor: pointer;
  line-height: 1;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.8);
}
</style>


